import { Components } from "@mui/material/styles";

export const MuiFormLabel: Components["MuiFormLabel"] = {
    styleOverrides: {
        root: {
            color: "var(--mui-palette-gray-800)",
            fontWeight: 700,
            fontSize: "16px",
            lineHeight: "1.5",
            marginBottom: "8px",
            marginInlineEnd: "24px",
            "&.Mui-focused": {
                color: "var(--mui-palette-gray-800)",
            },
            "&.Mui-error": {
                color: "var(--mui-palette-gray-800)",
            },
            "&.Mui-disabled": {
                color: "var(--mui-palette-gray-800)",
            },
        },
        asterisk: {
            color: "var(--mui-palette-error-main)",
        },
    },
};
